module.exports = __webpack_public_path__ + "S_right.e42bda88.png";